import type { BoxProps } from '@stitch-fix/mode-react';
import type { ModularComponent } from '../ModularPageWrapper';
type ResponsiveSizeValue = BoxProps['mt'];
export const getVerticalSpacing = <TModule extends ModularComponent,>(modules: TModule[]): TModule[] => {
  const modulesWithSpacing = modules.map((currentModule, index, moduleList) => {
    const previousModule: ModularComponent = moduleList[index - 1] ?? undefined;
    const currentModuleBackground: string | undefined = currentModule.props?.backgroundColor;
    const previousModuleBackground: string | undefined = previousModule?.props?.backgroundColor;
    let verticalSpacing: ResponsiveSizeValue;
    const heroModules = ['hero', 'galleryHero', 'dynamicAdsHero', 'videoFullBleedHero', 'interactiveImageScrollerHero'];
    const currentModuleIsHeroModule = heroModules.includes(currentModule?.type);
    const previousModuleIsHeroModule = heroModules.includes(previousModule?.type);
    const areStackedDisplayPanels = previousModule?.type === 'displayPanel' && currentModule.type === 'displayPanel';
    const areStackedDisplayTexts = previousModule?.type === 'displayText' && currentModule.type === 'displayText';
    const shouldUseReducedMobileSpacing = areStackedDisplayPanels || areStackedDisplayTexts;

    // Check if spacing should be default (empty)
    const shouldApplyDefaultSpacing = !previousModuleBackground || !currentModuleBackground || previousModuleBackground === 'white' || currentModuleBackground === 'white';

    // Check if spacing should remove stack spacing
    const shouldRemoveStackSpacing = index === 1 && currentModuleIsHeroModule || previousModuleIsHeroModule && currentModuleBackground && currentModuleBackground !== 'white';
    if (currentModule.type === 'displayText' && !areStackedDisplayTexts) {
      verticalSpacing = {};
    } else if (shouldRemoveStackSpacing) {
      verticalSpacing = {
        sm: '-3rem'
      }; // remove stack spacing
    } else if (shouldApplyDefaultSpacing) {
      verticalSpacing = {};
    } else if (currentModuleBackground === previousModuleBackground) {
      // remove stack spacing plus collapse extra spacing between modules with same background color
      verticalSpacing = {
        sm: shouldUseReducedMobileSpacing ? '-3rem' : '-6rem',
        lg: '-6rem'
      };
    } else {
      verticalSpacing = {
        sm: '-3rem'
      }; // remove stack spacing
    }
    const updatedModule = {
      ...currentModule,
      props: {
        verticalSpacing,
        ...currentModule.props
      }
    } as TModule;
    return updatedModule;
  });
  return modulesWithSpacing;
};